import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { TerminateStakeholderItemDto } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useUpdateTermination = () => {
  const { mutate: updateTermination, isPending } = useAppMutation(
    [QueryKey.PATCH_TERMINATE_STAKEHOLDERS],
    {
      mutationFn: ({
        companyId,
        data,
      }: {
        companyId: string;
        data: TerminateStakeholderItemDto[];
      }) =>
        ApiService.patch(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'stakeholders', 'terminate', 'update'],
          },
          { body: data },
        ),
    },
  );
  return { updateTermination, isPending };
};
